import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { RekbotsService } from '../../services/rekbots.service';
import { MatButtonModule } from '@angular/material/button';
import { Rekbot } from '../../models/rekbot.model';
import { RekbotFormComponent } from '../rekbot-layout/edit-rekbot/rekbot-form/rekbot-form.component';
@Component({
    selector: 'app-add-rekbot',
    standalone: true,
    imports: [
        RekbotFormComponent, MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule
    ],
    templateUrl: './add-rekbot.component.html',
    styleUrl: './add-rekbot.component.css'
})
export class AddRekbotComponent {

  elementId: number;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private rekbotsService: RekbotsService,
  ) {
    this.elementId = 0;
  }

  ngOnInit(): void {
    this.elementId = this.route.snapshot.params['rekbotId'];

    this.rekbotsService.setRekbot(<Rekbot> {
        id: 0,
        serial_no: "",
        ipv4: "",
        port: 8080,
        gps_device_id: "",
        status: 1,
        organization_id: 0
    });


  }

  onSubmit() {
    //console.log("submit")
  }


}
